export const COUNTDOWN_PLACEHOLDER = '{{countdown}}'
